import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="accounting-exports--form"
export default class extends Controller {
  static targets = [
    "ym", "fromDate", "toDate", "search", "csvBtn",
    "resultTable", "tab", "panel"
  ]
  static values = { rows: Array, errorCount: Number }

  connect() {
  }

  // When the year or month changes, automatically adjust the start and end dates to the first and last days of the month, respectively (manual adjustments are possible)
  syncMonth() {
    const ym = this.ymTarget.value
    if (!ym) return

    const [year, month] = ym.split("-").map(Number)
    const last = new Date(year, month, 0)
    this.fromDateTarget.value = `${ym}-01`
    this.toDateTarget.value = this.formatDate(last)
  }

  formatDate(d) {
    const m = String(d.getMonth() + 1).padStart(2, "0")
    const day = String(d.getDate()).padStart(2, "0")
    return `${d.getFullYear()}-${m}-${day}`
  }

  // Current year and month (YYYY-MM)
  currentYearMonth() {
    const now = new Date()
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`
  }

  run() {
    this.applyFilter()
  }

  clear() {
    this.ymTarget.value = this.currentYearMonth()
    this.syncMonth()
    this.searchTarget.value = ""
    this.applyFilter()
  }

  filter() {
    this.applyFilter()
  }

  applyFilter() {
    const q = (this.searchTarget.value || "").toLowerCase()
    this.resultTableTarget.querySelectorAll("tbody tr").forEach((tr) => {
      tr.classList.toggle("hidden", q && !tr.textContent.toLowerCase().includes(q))
    })
  }

  switchTab(event) {
    const tab = event.currentTarget.dataset.tab
    this.tabTargets.forEach((t) => t.classList.toggle("active", t.dataset.tab === tab))
    this.panelTargets.forEach((p) => p.classList.toggle("hidden", p.dataset.tab !== tab))
    document.getElementById("sectionTitle").textContent =
      tab === "error" ? "エラー一覧" : "パターン別仕訳結果"
  }

  downloadCsv() {
    if (this.errorCountValue > 0) {
      window.alert("未設定エラーがあるため、CSV出力できません。")
      return
    }

    const ym = this.ymTarget.value.replace("-", "/")
    const header = [
      "年月", "順番", "借方科目", "借方名称", "借方補助1", "借方補助2", "借方補助3", "借方金額",
      "貸方科目", "貸方名称", "貸方補助1", "貸方補助2", "貸方補助3", "貸方金額", "摘要"
    ]
    const lines = [header].concat(
      this.rowsValue.map((r) => [
        ym, r.no, r.debit, r.debit_name,
        r.d_aux1.code || "", r.d_aux2.code || "", r.d_aux3.code || "", r.debit_amount,
        r.credit, r.credit_name,
        r.c_aux1.code || "", r.c_aux2.code || "", r.c_aux3.code || "", r.credit_amount,
        r.credit_remark || r.debit_remark
      ])
    )
    const csv = lines
      .map((a) => a.map((v) => `"${String(v).replace(/"/g, '""')}"`).join(","))
      .join("\r\n")

    const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8" })
    const a = document.createElement("a")
    a.href = URL.createObjectURL(blob)
    a.download = `accounting_link_${this.ymTarget.value}.csv`
    a.click()
    URL.revokeObjectURL(a.href)
  }
}
